import React, { useState, useEffect } from 'react'
import Sidebar from '../Utilities/Sidebar'
import HeaderInner from '../Utilities/HeaderInner'
import Form from '../Utilities/Form'
import UpArrow from '../Utilities/UpArrow'
import InsideHeading from '../Utilities/InsideHeading'
import FooterInner from '../Utilities/FooterInner'
import ProductZoom from '../Utilities/ProductZoom'

const WelltooPro500 = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  }, []);

  const [display, setdisplay] = useState("none");
  const [productzoom, setproductzoom] = useState("none");

  const [image, setImage] = useState("https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704115558/Welltoo-Pro/Welltoo-Pro%20Choco/Product/3_dnndu0.webp");

  const showModal = () => {
    setdisplay("block");
  }

  const close = () => {
    setdisplay("none");
  }

  const zoom = () => {
    setproductzoom("block");
  }

  const closezoom = () => {
    setproductzoom("none");
  }

  const handleClick = (event) => {
    const src = event.target.src;
    setImage(src);
  }


  return (
    <div>
      <Form show={display} close={close} />
      <ProductZoom show={productzoom} close={closezoom} img={image} />
      <UpArrow />
      <div id='overview'></div>
      <HeaderInner />
      <div className="main">
        <Sidebar />

        <div className="main-body">
          {/* Overview */}
          <div className="overview">
            <div className="overview-img">
              <div className="overview-main">
                <img src={image} alt="Product" />
                <svg id="Capa_1" onClick={zoom} enable-background="new 0 0 461.363 461.363" height="512" viewBox="0 0 461.363 461.363" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m185.594 371.221c41.282.054 81.385-13.769 113.866-39.248l122.777 122.777c9.172 8.858 23.787 8.604 32.645-.568 8.641-8.947 8.641-23.131 0-32.077l-122.777-122.777c62.784-80.96 48.05-197.488-32.91-260.272s-197.487-48.051-260.272 32.909-48.05 197.488 32.91 260.272c32.548 25.241 72.572 38.932 113.761 38.915zm-98.652-284.342c54.484-54.485 142.82-54.486 197.305-.002s54.486 142.82.002 197.305-142.82 54.486-197.305.002c-.001-.001-.001-.001-.002-.002-54.484-53.706-55.113-141.412-1.407-195.896.466-.472.935-.941 1.407-1.407z" /><path d="m116.332 208.618h46.174v46.174c0 12.751 10.336 23.087 23.087 23.087s23.087-10.336 23.087-23.087v-46.174h46.174c12.751 0 23.087-10.336 23.087-23.087s-10.336-23.087-23.087-23.087h-46.174v-46.174c0-12.751-10.336-23.087-23.087-23.087s-23.087 10.336-23.087 23.087v46.174h-46.174c-12.751 0-23.087 10.336-23.087 23.087s10.336 23.087 23.087 23.087z" /></g></svg>
              </div>

              <div className="overview-img-content">
                <img id='img-1' onClick={handleClick} src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704115558/Welltoo-Pro/Welltoo-Pro%20Choco/Product/3_dnndu0.webp" alt="1" />
                <img id='img-2' onClick={handleClick} src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704115559/Welltoo-Pro/Welltoo-Pro%20Choco/Product/1_xw1v0q.webp" alt="2" />
                <img id='img-3' onClick={handleClick} src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704115558/Welltoo-Pro/Welltoo-Pro%20Choco/Product/2_odjwwf.webp" alt="3" />
                <img id='img-4' onClick={handleClick} src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704115558/Welltoo-Pro/Welltoo-Pro%20Choco/Product/3_dnndu0.webp" alt="4" />
              </div>
            </div>
            <div className="overview-text">
              <h3>Welltoo-Pro Choco</h3>
              <p className='tagline'>Build Repair & Recover</p>
              {/* <h6>Key Ingredients</h6> */}
              <p className='content'>It is a super advanced whey protein with addition of vitamin n minerals in it Whey protein is a
                mixture of beta-lactoglobulin, alpha lactalbumin, bovine serum albumin, and immunoglobins.
              </p>
              <button onClick={showModal}>
                Buy Now
                &emsp;
                <svg id="bold" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><circle cx="10.5" cy="22.5" r="1.5" /><circle cx="18.5" cy="22.5" r="1.5" /><path d="m24 6.5c0 3.584-2.916 6.5-6.5 6.5s-6.5-2.916-6.5-6.5 2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5zm-3.342-3.002c-.416-.364-1.047-.32-1.411.094l-2.796 3.196-1.244-1.244c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2 2c.409.409 1.079.387 1.459-.048l3.5-4c.364-.417.322-1.049-.094-1.412z" /><path d="m9 6.5c0-.169.015-.334.025-.5h-2.666l-.38-1.806c-.266-1.26-1.392-2.178-2.679-2.183l-2.547-.011c-.001 0-.002 0-.003 0-.413 0-.748.333-.75.747s.333.751.747.753l2.546.011c.585.002 1.097.42 1.218.992l.505 2.401 1.81 8.596h-.576c-1.241 0-2.25 1.009-2.25 2.25s1.009 2.25 2.25 2.25h15c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-15c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.499.001 13.5c.354 0 .661-.249.734-.596l.665-3.157c-1.431 1.095-3.213 1.753-5.149 1.753-4.687 0-8.5-3.813-8.5-8.5z" /></svg>
                <div id='about'></div>

              </button>

            </div>
          </div>

          {/* Overview ends */}

          {/* about  */}

          <InsideHeading
            id="key-ingredients"
            keyDisplay="none"
            benefitDisplay="none"
            h3="About"
            p="It is a super advanced whey protein with addition of vitamin n minerals in it Whey protein is a
            mixture of beta-lactoglobulin, alpha lactalbumin, bovine serum albumin, and immunoglobins.
            "
            p3dis="none"
            p4dis="none"
            p5dis="none"

          />
          {/* <div id='key-ingredients'></div> */}

          {/* about ends */}

          {/* key ingredients  */}
          <InsideHeading
            id="how-to-use"
            benefitDisplay="none"
            h3="key Ingredients"
            pdis="none"
            p2dis="none"
            p3dis="none"
            p4dis="none"
            p5dis="none"
            key1="Maltodextrin"
            key2="Vitamin & Minerals"
            key3="Skimmed Milk Powder"
            key4="Protein Hydrolysate"
            key5="Whey Protein"
            key6="Preservative"
            key7="Contains added flavor (Nature Identical & Artificial)"
            k8="none"
            k9="none"
            k10="none"
          />
          {/* key ingredients ends */}

          <InsideHeading
            id="how-it-works"
            keyDisplay="none"
            benefitDisplay="none"
            h3="How To Use"
            p="Use as directed on the label or as advised by your healthcare provider."
            p3dis="none"
            p4dis="none"
            p5dis="none"
          />

          {/* how to use ends */}

          {/* how it works  */}
          <InsideHeading
            benefitDisplay="none"
            keyDisplay="none"
            h3="How It Works"
            p="Welltoo Pro Protein Choco Powder is a post recovery drink scientifically engineered to boost
            endurance to train hard, build muscles to achieve core strength and recover quickly. It contains
            lycopene, a carotenoid (plant pigment), and an antioxidant that protects cells from damage by
            fighting against free radicals. It possesses the highest antioxidant activity among all carotenoids.
            It is found to be effective in significantly reducing the occurrence of preeclampsia and intrauterine
            growth restriction (IUGR). Lycopene is of its carotenoid cousins, which include beta-carotene. Its
            antioxidant actions help maintain the strength, thickness and fluidity of cell membranes."
            p3dis="none"
            p4dis="none"
            p5dis="none"

          />
          <div id="benefits"></div>

          {/* how it works ends */}

          {/* benefits  */}
          <InsideHeading
            id=""
            keyDisplay="none"
            h3="Benefits"
            pdis="none"
            p2dis="none"
            p3dis="none"
            p4dis="none"
            p5dis="none"
            benefit1="Aiding weight loss: In one study of 158 people, published in Nutrition & Metabolism Trusted
            Source, those who were given whey “lost significantly more body fat and showed a greater
            preservation of lean muscle compared to subjects consuming the control beverage."
            benefit2="Anti-cancer properties: Promising results were published in the journal Anticancer Research Trusted Source for the use of whey protein concentrate in cancer treatment."
            benefit3="Lowering cholesterol: A study, published in The British Journal of NutritionTrusted Source, gave whey supplements to 70 overweight men and women for 12 weeks and measured a number of parameters, such as lipid and insulin levels. They found that “there was a significant
            decrease in total cholesterol and LDL cholesterol at week 12 in the whey group compared with the casein (group)."
            benefit4="Asthma: Whey protein could improve the immune response in children with asthma. One small
            study involving 11 children, published in the International Journal of Food Science and
            NutritionTrusted Source, found that children with asthma who were supplemented with 10 gram
            whey protein twice daily for 1 month had an improved immune response."
            benefit5="Blood pressure and cardiovascular disease: Research published in the International Dairy
            Journal found that beverages that were supplemented with whey protein significantly
            reduced blood pressure in patients with hypertension; their risk of developing heart
            disease or stroke was also lower."
            benefit6="Reducing weight loss in people with HIV: A study published in the journal Clinical and
            Investigative Medicine found that whey protein may help reduce weight loss among HIV-positive
            patients."
            b7="none"
            b8="none"
            b9="none"
            b10="none"
          />
          {/* benefits ends */}

          {/* Indication  */}
          <div className="indications" id='indications' >
            <h3>Indications</h3>
            <div className="indications-content">
              <div className="indications-card">
                <div className="indications-img">
                  <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704173974/Welltoo-Pro/Welltoo-Pro%20500/Pregnancy_And_Lactation_xgzfzz.webp" alt="Pregnancy and Lactation" />
                </div>
                <div className="indications-text">
                  <p>Pregnancy and Lactation</p>
                </div>
              </div>

              <div className="indications-card">
                <div className="indications-img">
                  <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704173981/Welltoo-Pro/Welltoo-Pro%20500/General_Debility_mefpgb.webp" alt="General Debility" />
                </div>
                <div className="indications-text">
                  <p>General Debility</p>
                </div>
              </div>

              <div className="indications-card">
                <div className="indications-img">
                  <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704173977/Welltoo-Pro/Welltoo-Pro%20500/Immune_Defense_swizay.webp" alt="Immune Defense" />
                </div>
                <div className="indications-text">
                  <p>Immune Defense</p>
                </div>
              </div>

              <div className="indications-card">
                <div className="indications-img">
                  <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704173979/Welltoo-Pro/Welltoo-Pro%20500/Convalescence_pkpsw5.webp" alt="Convalescence" />
                </div>
                <div className="indications-text">
                  <p>Convalescence</p>
                </div>
              </div>

              <div className="indications-card">
                <div className="indications-img">
                  <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704173983/Welltoo-Pro/Welltoo-Pro%20500/Growing_Age_f7ilba.webp" alt="Growing Age" />
                </div>
                <div className="indications-text">
                  <p>Growing Age</p>
                </div>
              </div>

              <div className="indications-card">
                <div className="indications-img">
                  <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1704173975/Welltoo-Pro/Welltoo-Pro%20500/Mental_Performance_hw8juv.webp" alt="Mental Performance" />
                </div>
                <div className="indications-text">
                  <p>Mental Performance</p>
                </div>
              </div>

              <div id='safety-information'></div>
            </div>

          </div>
          {/* indications ends */}

          {/* Safety  */}
          <div className="safety" >
            <h3>Safety Information</h3>
            <div className="safety-content">
              <div className="safety-card">
                <div className="safety-img">
                  <svg id="Layer_5" enableBackground="new 0 0 62 62" height="512" viewBox="0 0 62 62" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><path d="m30 32h14v14h-14z" fill="#f0bc5e"></path></g><g><path d="m50 29h6v4h-6z" fill="#f0bc5e"></path></g><g><path d="m50 21h5v4h-5z" fill="#f0bc5e"></path></g><g><path d="m57.98 16.804c-.093-.468-.504-.804-.98-.804h-15c-2.206 0-4 1.794-4 4v8h-2v-13.46l-7-6v-2.54c1.103 0 2-.897 2-2 0-2.206-1.794-4-4-4h-10c-2.206 0-4 1.794-4 4 0 1.103.897 2 2 2v2.54l-7 6v13.46h-3c-.477 0-.887.336-.98.804l-4 20c-.059.294.018.599.207.83.19.232.473.366.773.366h7v7c0 2.757 2.243 5 5 5h18c2.757 0 5-2.243 5-5v-7h8c2.206 0 4-1.794 4-4v-8h13c.3 0 .583-.134.773-.366.189-.231.266-.536.207-.83zm-30.35-6.804 4.667 4h-20.594l4.667-4zm-4.63-4v2h-2v-2zm4 2h-2v-2h2zm-10-6h10c1.103 0 2 .897 2.001 2h-14.001c0-1.103.897-2 2-2zm2 4v2h-2v-2zm-9 10h24v12h-24zm24 41c0 1.654-1.346 3-3 3h-18c-1.654 0-3-1.346-3-3v-7h24zm12-11c0 1.103-.897 2-2 2h-41.78l3.6-18h38.18c.728 0 1.411-.195 2-.537zm-2-18h-4v-4.556c.59.344 1.268.556 2 .556h2c1.103 0 2 .897 2 2s-.898 2-2 2zm4 8v-10c0-2.206-1.794-4-4-4h-2c-1.103 0-2-.897-2-2s.897-2 2-2h14.18l3.6 18z"></path><path d="m8 46h20v-14h-20zm2-12h16v10h-16z"></path><path d="m30 32h2v2h-2z"></path><path d="m34 32h10v2h-10z"></path><path d="m30 36h14v2h-14z"></path><path d="m30 40h14v2h-14z"></path><path d="m30 44h4v2h-4z"></path><path d="m36 44h8v2h-8z"></path><path d="m50 32h6v2h-6z"></path><path d="m50 28h6v2h-6z"></path><path d="m50 24h5v2h-5z"></path><path d="m50 20h5v2h-5z"></path></g></g></svg>
                </div>
                <div className="safety-text">
                  <p>Read the label carefully before use</p>
                </div>
              </div>

              {/* <div className="safety-card">
                <div className="safety-img">
                  <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Flat"><g id="Color"><rect fill="#576b7a" height="4" rx="1" width="34" x="3" y="3" /><path d="m32.13 14h-24.26a1.94 1.94 0 0 1 -1.87-2v-5h28v5a1.94 1.94 0 0 1 -1.87 2z" fill="#465867" /><path d="m31 17.86v-3.86h-22v3.86a4 4 0 0 1 -1.78 3.33l-2.44 1.62a4 4 0 0 0 -1.78 3.33v30.86a4 4 0 0 0 4 4h26a4 4 0 0 0 4-4v-30.86a4 4 0 0 0 -1.78-3.33l-2.44-1.62a4 4 0 0 1 -1.78-3.33z" fill="#9de0e0" /><path d="m33 32.5v22.5a2 2 0 0 1 -2 2h-22a2 2 0 0 1 -2-2v-22.35c9.34-10.48 15.53 6.46 26-.15z" fill="#008b81" /><path d="m3 38h34v14h-34z" fill="#e4f4fd" /><path d="m49 3a12 12 0 0 0 -12 12 12.24 12.24 0 0 0 .4 3l-3.4 6h7.12a12 12 0 1 0 7.88-21z" fill="#2e3d4c" /><path d="m49 37a12 12 0 0 0 -9.66 4.9l-6.71 1.19 4.37 5.24v.67a12 12 0 1 0 12-12z" fill="#2e3d4c" /><path d="m52.54 49.5 1.46-1.41a2.5 2.5 0 0 0 -3.54-3.54l-1.46 1.45-1.41-1.41a2.5 2.5 0 0 0 -3.54 3.54l1.41 1.41-1.41 1.41a2.5 2.5 0 0 0 3.54 3.54l1.41-1.49 1.41 1.41a2.5 2.5 0 0 0 3.59-3.5z" fill="#e13332" /><path d="m52.18 10.82-4.59 4.59-1.77-1.76a2.5 2.5 0 0 0 -3.54 0 2.5 2.5 0 0 0 0 3.53l3.54 3.54a2.5 2.5 0 0 0 3.53 0l6.37-6.37a2.5 2.5 0 0 0 0-3.53 2.5 2.5 0 0 0 -3.54 0z" fill="#00a99d" /><path d="m12 44h16a1 1 0 0 0 0-2h-16a1 1 0 0 0 0 2z" fill="#c9dfeb" /><path d="m28 46h-16a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2z" fill="#c9dfeb" /><g fill="#7dcccc"><path d="m20 21a1 1 0 0 0 0-2h-11.17a4 4 0 0 1 -1.36 2z" /><circle cx="24" cy="20" r="1" /></g></g></g></svg>
                </div>
                <div className="safety-text">
                  <p> Do not exceed the recommended dose</p>
                </div>
              </div> */}

              <div className="safety-card">
                <div className="safety-img">
                  <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Artboard_04" data-name="Artboard 04"><path d="m16 27a6 6 0 1 0 6-6 6.006 6.006 0 0 0 -6 6zm8 0a2 2 0 1 1 -2-2 2 2 0 0 1 2 2z" fill="#a3d4ff" /><path d="m19.426 13.929 2.184.127-1.334-1.735a5.887 5.887 0 0 1 -1.255-2.821c-.163-1.5.573-2.841 2.184-3.989l.888-.632-.706-.83a5.806 5.806 0 0 0 -2.173-1.52 6.668 6.668 0 0 0 -2.596-.529 6.216 6.216 0 0 0 -5.28 2.84c-.806 1.258-1.994 3.666-.9 5.67 1.09 1.99 4.113 3.137 8.988 3.419z" fill="#a3d4ff" /><path d="m51 44a1 1 0 0 1 -1-1v-3h-6v3a1 1 0 0 1 -1 1 2 2 0 0 0 -2 2v2h12v-2a2 2 0 0 0 -2-2z" fill="#a3d4ff" /><path d="m41 55a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2h-12z" fill="#a3d4ff" /><path d="m35.251 32.182-.645-1.266-.973 1.034a15.924 15.924 0 0 1 -23.267 0l-.966-1.032-.647 1.259c-.31.6-.6 1.219-.881 1.839l-.948 1.92-.831 2.826c-2.66 9.041-.555 16.081 6.086 20.359a18.183 18.183 0 0 0 19.65 0 17.641 17.641 0 0 0 2.79-2.221l.606-.6-.49-.694a14.964 14.964 0 0 1 -1.34-2.332l-.315-.68-.74.111a21.532 21.532 0 0 1 -3.181.259 22.335 22.335 0 0 1 -10.819-2.833l.366-.116a42.135 42.135 0 0 0 13.725-7.19l.22-.184.09-.274a15.107 15.107 0 0 1 3.7-6.009l.474-.469-.252-.618c-.425-1.046-.9-2.085-1.412-3.089z" fill="#a3d4ff" /><g fill="#274d80"><path d="m13 17h6v2h-6z" /><path d="m25 17h6v2h-6z" /><path d="m22 30a3 3 0 1 0 -3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1 -1 1 1 1 0 0 1 1-1z" /><path d="m15 31h1.264a6.984 6.984 0 0 0 11.472 0h1.264a4 4 0 0 0 0-8h-1.264a6.984 6.984 0 0 0 -11.472 0h-1.264a4 4 0 0 0 0 8zm14-6a2 2 0 0 1 0 4h-.3a6.927 6.927 0 0 0 0-4zm-7-3a5 5 0 1 1 -5 5 5.006 5.006 0 0 1 5-5zm-7 3h.3a6.927 6.927 0 0 0 0 4h-.3a2 2 0 0 1 0-4z" /><path d="m47 31a15.9 15.9 0 0 0 -9.665 3.279c-.568-1.333-1.13-2.457-1.592-3.313a16.929 16.929 0 0 0 2.511-4.992 4.979 4.979 0 0 0 0-9.948 17.019 17.019 0 0 0 -15.654-11.996 6.147 6.147 0 0 0 -3-2.426 7.358 7.358 0 0 0 -9.1 2.696 7.3 7.3 0 0 0 -1.34 5.592 16.917 16.917 0 0 0 -3.4 6.134 4.98 4.98 0 0 0 0 9.949 16.955 16.955 0 0 0 2.512 4.994c-5.288 9.708-7.102 22.253 3.363 28.993a19.184 19.184 0 0 0 20.731 0 18.538 18.538 0 0 0 2.817-2.213 15.989 15.989 0 1 0 11.817-26.749zm-6-10a3 3 0 0 1 -2.266 2.9 15.919 15.919 0 0 0 0-5.8 3 3 0 0 1 2.266 2.9zm-19-16.024v.024l-.012-.02zm-9.82.4a5.226 5.226 0 0 1 4.438-2.376 5.688 5.688 0 0 1 2.208.45 4.7 4.7 0 0 1 1.8 1.246c-2.375 1.692-2.743 3.572-2.6 4.91a6.8 6.8 0 0 0 1.457 3.327c-5.542-.321-7.514-1.713-8.166-2.9-.848-1.556.176-3.584.863-4.655zm-9.18 15.624a3 3 0 0 1 2.257-2.9 16.178 16.178 0 0 0 .009 5.8 3 3 0 0 1 -2.266-2.9zm7.143-9.183c1.821 2.137 5.713 3.183 11.857 3.183a1 1 0 0 0 .459-1.889c-.383-.265-2.506-2.146-2.46-4.077.027-1.1.794-2.115 2.265-3.02a14.991 14.991 0 1 1 -12.121 5.8zm11.857 26.183a16.939 16.939 0 0 0 12.36-5.364c.41.8.9 1.832 1.379 3.012a16.024 16.024 0 0 0 -3.949 6.409 41.443 41.443 0 0 1 -13.387 7c-5.287-3.018-9.155-8.02-10.235-13.217.5-1.235 1.014-2.324 1.47-3.211a16.938 16.938 0 0 0 12.362 5.371zm9.738 13.8a21.078 21.078 0 0 1 -10.792-1.494 45.108 45.108 0 0 0 10.183-5.239 15.546 15.546 0 0 0 .609 6.733zm-.455 6.48a17.174 17.174 0 0 1 -18.566 0c-7.777-5.009-7.492-13.037-5.669-19.236a24.337 24.337 0 0 0 22.111 14.92 22.5 22.5 0 0 0 3.328-.271 15.955 15.955 0 0 0 1.431 2.489 16.446 16.446 0 0 1 -2.635 2.098zm15.717 2.72a14 14 0 1 1 14-14 14.015 14.015 0 0 1 -14 14z" /><path d="m51 43v-2.278a1.993 1.993 0 0 0 1-1.722v-2a2 2 0 0 0 -2-2h-6a2 2 0 0 0 -2 2v2a1.993 1.993 0 0 0 1 1.722v2.278a3 3 0 0 0 -3 3v9a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-9a3 3 0 0 0 -3-3zm-7-6h6v2h-6zm-1 8a2 2 0 0 0 2-2v-2h4v2a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1h-10v-1a1 1 0 0 1 1-1zm9 4v3h-10v-3zm-1 7h-8a1 1 0 0 1 -1-1v-1h10v1a1 1 0 0 1 -1 1z" /></g></g></svg>
                </div>
                <div className="safety-text">
                  <p>Keep out of reach of children</p>
                </div>
              </div>


              <div className="safety-card">
                <div className="safety-img">
                  <svg fill="none" height="512" viewBox="0 0 120 120" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m79 36c-13.2548 0-24 10.7452-24 24s10.7452 24 24 24 24-10.7452 24-24-10.7452-24-24-24z" fill="#a7baff" /><g fill="#2140ae"><path d="m78 46c-2.2091 0-4 1.7909-4 4v11.3214l-2.5442-1.9788c-1.7438-1.3563-4.2569-1.0422-5.6131.7016-1.3563 1.7438-1.0422 4.2569.7016 5.6132l7.7721 6.045c2.1667 1.6852 5.2006 1.6852 7.3673 0l7.7721-6.045c1.7438-1.3563 2.0579-3.8694.7017-5.6132-1.3563-1.7438-3.8694-2.0579-5.6132-.7016l-2.5443 1.9789v-11.3215c0-2.2091-1.7909-4-4-4z" /><path clipRule="evenodd" d="m71 32.9163v-6.9163c0-8.8366-7.1634-16-16-16s-16 7.1634-16 16v36.5295c0 .6155-.2865 1.1931-.7569 1.5899-5.6526 4.7694-9.2431 11.9057-9.2431 19.8806 0 14.3594 11.6406 26 26 26 13.74 0 24.9907-10.658 25.9357-24.1578 13.5308-1.463 24.0643-12.9225 24.0643-26.8422 0-14.9117-12.0883-27-27-27-2.421 0-4.7675.3186-7 .9163zm-16-14.9163c-4.4183 0-8 3.5817-8 8v36.5295c0 3.1309-1.4506 5.8925-3.5979 7.7043-3.9282 3.3143-6.4021 8.2474-6.4021 13.7662 0 9.9411 8.0589 18 18 18 9.4272 0 17.1617-7.2471 17.9362-16.4741-1.7079-.324-3.3588-.809-4.9365-1.4384-.047 7.1394-5.8492 12.9125-12.9997 12.9125-7.1797 0-13-5.8203-13-13 0-5.7841 3.7775-10.6859 9-12.373v-11.627c0-9.3824 4.0796-18.1516 12-23.4534v-10.5466c0-4.4183-3.5817-8-8-8zm5 66c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5zm18-44c-10.4934 0-19 8.5066-19 19s8.5066 19 19 19 19-8.5066 19-19-8.5066-19-19-19z" fillRule="evenodd" /><path d="m21 20c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4h10c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4z" /><path d="m17 46c0-2.2091 1.7909-4 4-4h10c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4h-10c-2.2091 0-4-1.7909-4-4z" /><path d="m27 31c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4h4c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4z" /><path d="m21 57c0-2.2091 1.7909-4 4-4h6c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4h-6c-2.2091 0-4-1.7909-4-4z" /></g></svg>
                </div>
                <div className="safety-text">
                  <p>Store in a cool, dry place away from direct sunlight</p>
                </div>
              </div>



            </div>

          </div>
          {/* Safety ends */}

        </div>
      </div>

      <FooterInner />
    </div>
  )
}

export default WelltooPro500
